import { CREATE_CASEVERSIONS, GET_ALL_LIST } from '../types'

const INITIAL_STATE = {
  caseVersions: [],
  allListVersions: [],
}

const caseVersionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CREATE_CASEVERSIONS:
      return {
        ...state,
        caseVersions: payload.data,
      }
    case GET_ALL_LIST:
      return {
        ...state,
        allListVersions: payload.data,
      }
    default:
      return state
  }
}

export default caseVersionReducer
